import { db, auth, storage } from '../firebase';
import { doc, setDoc, getDoc, collection, getDocs } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export class FirebaseDebugger {
  
  // 1. Firebase konfigürasyon kontrolü
  static checkConfig() {
    
    return {
      apiKey: !!process.env.REACT_APP_FIREBASE_API_KEY,
      projectId: !!process.env.REACT_APP_FIREBASE_PROJECT_ID,
      authDomain: !!process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      storageBucket: !!process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
    };
  }

  // 2. Firestore bağlantı testi
  static async testFirestore() {
    
    try {
      // Test dokümanı oluştur
      const testDocRef = doc(db, 'test', 'connection-test');
      const testData = {
        message: 'Firebase bağlantı testi',
        timestamp: new Date().toISOString(),
        success: true
      };

      await setDoc(testDocRef, testData);

      const docSnap = await getDoc(testDocRef);
      
      if (docSnap.exists()) {
        return { success: true, data: docSnap.data() };
      } else {
        return { success: false, error: 'Document not found' };
      }

    } catch (error: any) {
      console.error('❌ Firestore Hatası:', error);
      console.error('Hata Detayları:', {
        code: error.code,
        message: error.message,
        stack: error.stack
      });
      return { success: false, error: error.message };
    }
  }

  // 3. Firestore koleksiyonları kontrol et
  static async checkCollections() {
    
    try {
      // Products koleksiyonu
      const productsRef = collection(db, 'products');
      const productsSnap = await getDocs(productsRef);

      // Categories koleksiyonu  
      const categoriesRef = collection(db, 'categories');
      const categoriesSnap = await getDocs(categoriesRef);

      return {
        products: productsSnap.size,
        categories: categoriesSnap.size
      };

    } catch (error: any) {
      console.error('❌ Koleksiyon kontrolü hatası:', error);
      return { error: error.message };
    }
  }

  // 4. Firebase Storage testi
  static async testStorage() {
    
    try {
      // Test dosyası oluştur (küçük text dosyası)
      const testContent = 'Firebase Storage Test - ' + new Date().toISOString();
      const testBlob = new Blob([testContent], { type: 'text/plain' });
      const testFile = new File([testBlob], 'test.txt', { type: 'text/plain' });

      // Storage referansı
      const storageRef = ref(storage, 'test/connection-test.txt');
      
      const snapshot = await uploadBytes(storageRef, testFile);

      const downloadURL = await getDownloadURL(snapshot.ref);

      return { success: true, downloadURL };

    } catch (error: any) {
      console.error('❌ Storage Hatası:', error);
      return { success: false, error: error.message };
    }
  }

  // 5. Auth durumu kontrol et
  static checkAuth() {
    
    return {
      isAuthenticated: !!auth.currentUser,
      user: auth.currentUser
    };
  }

  // 6. Kapsamlı Firebase testi
  static async runFullTest() {

    const results = {
      config: this.checkConfig(),
      auth: this.checkAuth(),
      firestore: null as any,
      collections: null as any,
      storage: null as any
    };

    try {
      results.firestore = await this.testFirestore();
      results.collections = await this.checkCollections();
      results.storage = await this.testStorage();

      // Özet
      const allTests = [
        results.config.apiKey && results.config.projectId,
        results.firestore?.success,
        results.storage?.success
      ];

      const successCount = allTests.filter(Boolean).length;
      const totalTests = allTests.length;

      return results;

    } catch (error) {
      console.error('❌ Test sırasında genel hata:', error);
      return { ...results, generalError: error };
    }
  }
}

// Window objesi üzerinden erişilebilir yap
if (typeof window !== 'undefined') {
  (window as any).FirebaseDebugger = FirebaseDebugger;
}